import React from 'react';
import { useRegionReportController } from './useRegionReportController';
import { LoadingView } from './views/LoadingView';
import { DeleteConfirmationView } from './views/DeleteConfirmationView';
import { CloseConfirmationView } from './views/CloseConfirmationView';
import { NoHarvestDataView } from './views/NoHarvestDataView';
import { ReportContentView } from './views/ReportContentView';

export type RegionReportProps = {
  index: number;
};

export const RegionReport = ({
  index
}: RegionReportProps) => {
  const {
    activity,
    activityExists,
    closeConfirmationModal,
    cropCode,
    deleteConfirmationModal,
    fieldBoundary,
    fieldName,
    geoJson,
    hasRegionReportData,
    isAirSeeder,
    isDetailView,
    isListView,
    isLoadingReport,
    isRegionValid,
    itemData,
    locale,
    onCancelClick,
    onCancelConfirm,
    onCancelGoBack,
    onDeleteCancelConfirm,
    onDeleteCancelGoBack,
    onDeleteConfirm,
    onItemClick,
    onNotePadClick,
    onRegionButtonClick,
    onStep2Click,
    reportData,
    saveClick,
    showSaveButton,
  } = useRegionReportController({ index });

  if (isLoadingReport) {
    return <LoadingView onCancelClick={onCancelConfirm} />;
  }

  if (deleteConfirmationModal) {
    return (
      <DeleteConfirmationView
        onDeleteCancelConfirm={onDeleteCancelConfirm}
        onDeleteCancelGoBack={onDeleteCancelGoBack}
        onCancelConfirm={onCancelConfirm}
      />
    );
  }

  if (closeConfirmationModal) {
    return (
      <CloseConfirmationView
        onCancelConfirm={onCancelConfirm}
        onCancelGoBack={onCancelGoBack}
      />
    );
  }

  if (!isLoadingReport && !hasRegionReportData) {
    return (
      <NoHarvestDataView
        activity={activity}
        activityExists={activityExists}
        fieldName={fieldName}
        geoJson={geoJson}
        isRegionValid={isRegionValid}
        locale={locale}
        onCancelConfirm={onCancelConfirm}
        onDeleteConfirm={onDeleteConfirm}
        onRegionButtonClick={onRegionButtonClick}
        saveClick={saveClick}
        showSaveButton={showSaveButton}
      />
    );
  }

  return (
    <ReportContentView
      activity={activity}
      cropCode={cropCode}
      fieldBoundary={fieldBoundary}
      fieldName={fieldName}
      index={index}
      isAirSeeder={isAirSeeder}
      isDetailView={isDetailView}
      isListView={isListView}
      itemData={itemData}
      locale={locale}
      onCancelClick={onCancelClick}
      onDeleteConfirm={onDeleteConfirm}
      onItemClick={onItemClick}
      onNotePadClick={onNotePadClick}
      onStep2Click={onStep2Click}
      reportData={reportData}
      saveClick={saveClick}
      showSaveButton={showSaveButton}
    />
  );
};
